<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">New Scale</h2>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
        <div class="view gradient-card-header primary-gradient white-text">
            <h3 class='h3-responsive text-center'>{{scale.name}}</h3>
        </div>
        <div class="card-body">
        <form>
          <div class="form-group">
            <label for="name">Name:</label>
            <input class="form-control" type="text" id="name" name="name" [(ngModel)]="scale.name" />
          </div>
          <div class="form-group">
              <label for="name">Client Description:</label>
              <input class="form-control" type="text" id="descriptionClient" name="descriptionClient" [(ngModel)]="scale.descriptionClient" />
          </div>
          <div class="form-group">
              <label for="name">Therapist Description:</label>
              <input class="form-control" type="text" id="descriptionTherapist" name="descriptionTherapist" [(ngModel)]="scale.descriptionTherapist" />
          </div>
          <div class="form-group">
            <label for="multiplier">Multiplier:</label>
            <input class="form-control" type="number" id="multiplier" name="multiplier" [(ngModel)]="scale.multiplier" />
          </div>
          <div class="form-group">
            <input class="form-control" type="checkbox" id="negToPositive" name="negToPositive" [(ngModel)]="scale.negativeToPositiveRanges" />
            <label for="negToPositive">Negative to Positive Ranges:</label>
          </div>
          <!--<div class="form-group">
            <label for="displayOrder">Display Order:</label>
            <input class="form-control" type="number" id="displayOrder" [(ngModel)]="scale.display_order" />
          </div>-->
        </form>
        <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
        <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/scale-new/scale-new.component.html